import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AddLeadComponent } from './addlead.component';
//import { LeadsService } from '../../services/lead-service/lead-service.service';
import {SlimLoadingBarModule} from 'ng2-slim-loading-bar';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { Http, Response } from '@angular/http';
import { FormsModule} from '@angular/forms';
import { FormBuilder, NgForm, NgModel, Validators, ValidatorFn } from '@angular/forms'

import { NgSelectModule } from '@ng-select/ng-select';
import { Ng2TelInputModule } from 'ng2-tel-input';
import { HeaderModule } from '../../layout/header/header.module';


@NgModule({
  declarations: [
    AddLeadComponent
  ],
  imports: [
    BrowserModule,FormsModule,SlimLoadingBarModule.forRoot(),
    SweetAlert2Module,
    NgSelectModule,
    HeaderModule,
    Ng2TelInputModule
  ],
  providers: [Http,FormBuilder],
  bootstrap: [AddLeadComponent],
  exports: [AddLeadComponent,SlimLoadingBarModule],
})
export class AddLeadModule { }



// WEBPACK FOOTER //
// ./src/app/lead/addLead/addlead.module.ts